import fetch, { Headers, RequestInit } from 'node-fetch';
import { getAppEnv } from "../configs/SetAppEnvConfig";
import ApiSendRequestResult from "../models/ApiSendRequestResult";
import { EnvNames } from "../models/EnvNames";
import { HttpErrorResponse } from "../models/HttpError";
import PixagriScopes from "../models/PixagriScopes";
import { logger } from "./LogService";
import { getResponseJsonNoError } from "./ResponseHelper";

export class BasePixagriApiService {

    static BUSINESS_LINE_PARAM_KEY = `businessLine`;
    static BUSINESS_LINE_PARAM = `:${BasePixagriApiService.BUSINESS_LINE_PARAM_KEY}`;

    PIXAGRI_ROOT_URL_DEV = "https://pixagri-api-s2nygtk3nq-ew.a.run.app/api/v1/agri";
    PIXAGRI_ROOT_URL_PREPROD = "https://pixagri-api-preprod-ccgfqp5o5q-ew.a.run.app/api/v1/agri";

    PIXAGRI_ROOT_URL_PROD = "https://pixagri-api-ccgfqp5o5q-ew.a.run.app/api/v1/agri";

    CAMPAIGN_ENDPOINT = PixagriScopes.CAMPAIGN
    CAMPAIGN_PARAM = `:campaignId`;

    FIELD_PARAM = `:fieldRef`;

    PROCESSING_PARAM = `:processingType`;

    INDICATOR_PARAM = `:indicatorType`;

    DISTRIBUTOR_PARAM = ":distributorRef";

    ORGANIZATION_PARAM = ":organizationRef";

    PRODUCER_PARAM = ":producerRef";

    NOTE_PARAM = ":noteId"

    getPixagriRootApiUrl = () => {
        let url = ""
        switch (getAppEnv()) {
            case EnvNames.PREPROD:
                url = this.PIXAGRI_ROOT_URL_PREPROD;
                break;
            case EnvNames.PROD:
                url = this.PIXAGRI_ROOT_URL_PROD;
                break;
            case EnvNames.DEV:
                url = this.PIXAGRI_ROOT_URL_DEV;
                break;

            default:
                url = this.PIXAGRI_ROOT_URL_DEV;
                break;
        }
        return url
    }

    async sendRequest<ResponseType>(
        credentials: string,
        url: string,
        method: 'GET' | 'POST' | 'PUT' | 'DELETE',
        body?: any,
        doNotLogResponse?: boolean,
    ): Promise<ApiSendRequestResult<ResponseType>> {
        logger.info(`Send notification-data-api request: ${url}`, { body });

        const requestOptions = await this.getRequestOptions(
            credentials,
            method,
            body,
        );
        const response = await fetch(url, requestOptions);
        const responseData = (await getResponseJsonNoError(
            response,
            true,
        )) as ResponseType;
        logger.info(
            `pixagri-api response ${response.status} for api path ${url}`,
            doNotLogResponse
                ? {}
                : {
                    response: responseData,
                },
        );
        const error = !response.ok;
        let error_message = '';
        if (error) {
            const errorData = responseData as HttpErrorResponse;
            error_message = errorData.message;
        }
        return {
            error,
            error_message: error_message,
            url: url,
            response: responseData,
            status: response.status,
        };
    }

    async getRequestOptions(
        credentials: string,
        method: 'GET' | 'POST' | 'PUT' | 'DELETE',
        body?: any,
    ): Promise<RequestInit> {
        const headers = this.generateRequestHeader(credentials);

        const requestOptions: RequestInit = {
            method: method,
            headers: headers,
            redirect: 'follow',
        };

        if (body) {
            requestOptions.body = JSON.stringify(body);
        }
        return requestOptions;
    }

    generateRequestHeader(credentials: string): Headers {
        const header = new Headers();
        header.append('Authorization', `Bearer ${credentials}`);
        header.append('Content-Type', `application/json`);

        return header;
    }

}